export const Radio = {
  baseStyle: () => ({
    control: {
      border: '2px solid',
      borderColor: 'product.border.solid',
      _checked: {
        background: 'white',
        borderColor: `product.secondary`,
        color: `product.secondary`,
        border: '5px solid',
        _before: {
          color: 'white',
        },
        _hover: {
          background: 'white',
          borderColor: `product.secondary`,
        },
      },
      label: {
        color: 'red',
      },
    },
  }),
  variants: {
    suggestion: {
      control: {
        borderColor: 'product.text.dark.bodySolid',
      },
    },
  },
}
